/* prettier-ignore */

export var colorsClassesMap = {
  secondary_button_10: 'color_secondary_button_10',
  superblack_40: 'color_superblack_40',
  superblack_60: 'color_superblack_60',
  superblack_10: 'color_superblack_10',
  superblack_100: 'color_superblack_100',
  superblack_20: 'color_superblack_20',
  superblack_6: 'color_superblack_6',
  success_100: 'color_success_100',
  success_10: 'color_success_10',
  error_100: 'color_error_100',
  error_10: 'color_error_10',
  sokolniki_100: 'color_sokolniki_100',
  fill_primary_active_100: 'color_fill_primary_active_100',
  purple_label_80: 'color_purple_label_80',
  zamoskvoreckaya_100: 'color_zamoskvoreckaya_100',
  fill_error_primary_active_100: 'color_fill_error_primary_active_100',
  arbatskaya_100: 'color_arbatskaya_100',
  fill_success_secondary_active_20: 'color_fill_success_secondary_active_20',
  filevskaya_100: 'color_filevskaya_100',
  kolcevaia_100: 'color_kolcevaia_100',
  fill_primary_hover_100: 'color_fill_primary_hover_100',
  purple_label_100: 'color_purple_label_100',
  rijckaya_100: 'color_rijckaya_100',
  fill_secondary_active_30: 'color_fill_secondary_active_30',
  taganskaya_100: 'color_taganskaya_100',
  fill_success_primary__active_100: 'color_fill_success_primary__active_100',
  colncevo_100: 'color_colncevo_100',
  fill_success_primary__hover_100: 'color_fill_success_primary__hover_100',
  temirazevskaya_100: 'color_temirazevskaya_100',
  fill_error_secondary__active_20: 'color_fill_error_secondary__active_20',
  lublino_100: 'color_lublino_100',
  fill_error_secondary_hover_16: 'color_fill_error_secondary_hover_16',
  big_kolcevaya_100: 'color_big_kolcevaya_100',
  fill_error_primary_hover_100_: 'color_fill_error_primary_hover_100_',
  butovo_100: 'color_butovo_100',
  monorels_100: 'color_monorels_100',
  fill_success_secondary_hover_16: 'color_fill_success_secondary_hover_16',
  mck_100: 'color_mck_100',
  fill_secondary_hover_20: 'color_fill_secondary_hover_20',
  purple_label_10: 'color_purple_label_10',
  kommynarskaya_100: 'color_kommynarskaya_100',
  gray_icons_100: 'color_gray_icons_100',
  black_icons_60: 'color_black_icons_60',
  black_control_80: 'color_black_control_80',
  white_icons_60: 'color_white_icons_60',
  warning_100: 'color_warning_100',
  warning15_100: 'color_warning15_100',
  focused_15: 'color_focused_15',
  black_100: 'color_black_100',
  primary_100: 'color_primary_100',
  primary_10: 'color_primary_10',
  gray60_100: 'color_gray60_100',
  gray40_100: 'color_gray40_100',
  gray20_100: 'color_gray20_100',
  gray10_100: 'color_gray10_100',
  gray6_100: 'color_gray6_100',
  black_60: 'color_black_60',
  black_40: 'color_black_40',
  black_20: 'color_black_20',
  black_10: 'color_black_10',
  black_6: 'color_black_6',
  white_100: 'color_white_100',
  white_60: 'color_white_60',
  white_40: 'color_white_40',
  white_10: 'color_white_10',
  white_20: 'color_white_20',
  white_6: 'color_white_6',
  fill_white_secondary_30: 'color_fill_white_secondary_30',
  current_color: 'color_current_color'
};
export var colors = {
  secondary_button_10: 'rgba(4,104,255,0.1)',
  superblack_40: 'rgba(0,0,0,0.4)',
  superblack_60: 'rgba(0,0,0,0.6)',
  superblack_10: 'rgba(0,0,0,0.1)',
  superblack_100: '#000',
  superblack_20: 'rgba(0,0,0,0.2)',
  superblack_6: 'rgba(0,0,0,0.05)',
  success_100: '#3ac500',
  success_10: 'rgba(58,197,0,0.1)',
  error_100: '#ff1f34',
  error_10: 'rgba(255,31,52,0.1)',
  sokolniki_100: '#ef161e',
  fill_primary_active_100: '#075ad9',
  purple_label_80: 'rgba(135,41,255,0.8)',
  zamoskvoreckaya_100: '#2dbe2c',
  fill_error_primary_active_100: '#d02037',
  arbatskaya_100: '#0078be',
  fill_success_secondary_active_20: 'rgba(64,109,46,0.2)',
  filevskaya_100: '#00bfff',
  kolcevaia_100: '#8d5b2d',
  fill_primary_hover_100: '#0661ec',
  purple_label_100: '#8729ff',
  rijckaya_100: '#ed9121',
  fill_secondary_active_30: 'rgba(24,69,135,0.3)',
  taganskaya_100: '#800080',
  fill_success_primary__active_100: '#33a40d',
  colncevo_100: '#ffd702',
  fill_success_primary__hover_100: '#36b507',
  temirazevskaya_100: '#999',
  fill_error_secondary__active_20: 'rgba(158,34,45,0.2)',
  lublino_100: '#9c0',
  fill_error_secondary_hover_16: 'rgba(187,44,57,0.15)',
  big_kolcevaya_100: '#82c0c0',
  fill_error_primary_hover_100_: '#e81f35',
  butovo_100: '#a1b3d4',
  monorels_100: '#99f',
  fill_success_secondary_hover_16: 'rgba(76,146,47,0.15)',
  mck_100: '#de64a1',
  fill_secondary_hover_20: 'rgba(15,72,157,0.2)',
  purple_label_10: 'rgba(135,41,255,0.1)',
  kommynarskaya_100: '#d8d8d8',
  gray_icons_100: '#737a8e',
  black_icons_60: 'rgba(21,34,66,0.6)',
  black_control_80: 'rgba(0,0,0,0.8)',
  white_icons_60: 'rgba(255,255,255,0.6)',
  warning_100: '#ff7e00',
  warning15_100: '#fff5d4',
  focused_15: '#83b4ff',
  black_100: '#152242',
  primary_100: '#0468ff',
  primary_10: 'rgba(4,104,255,0.1)',
  gray60_100: '#737a8e',
  gray40_100: '#a1a7b3',
  gray20_100: '#ced1d7',
  gray10_100: '#e8e9ec',
  gray6_100: '#f1f2f4',
  black_60: 'rgba(21,34,66,0.6)',
  black_40: 'rgba(21,34,66,0.4)',
  black_20: 'rgba(21,34,66,0.2)',
  black_10: 'rgba(21,34,66,0.1)',
  black_6: 'rgba(21,34,66,0.05)',
  white_100: '#fff',
  white_60: 'rgba(255,255,255,0.6)',
  white_40: 'rgba(255,255,255,0.4)',
  white_10: 'rgba(255,255,255,0.1)',
  white_20: 'rgba(255,255,255,0.2)',
  white_6: 'rgba(255,255,255,0.05)',
  fill_white_secondary_30: 'rgba(255,255,255,0.3)',
  current_color: 'currentColor'
};